import React, { useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from "react-router-dom";
import useGlobal from "../../store";
import { searchGraph } from "../../services/MetadataService";

 const SearchBox = (props) => {
	const [options, setOptions] = useState([]);
	const [searchTerm, setSearchTerm] = useState();
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

	let history = useHistory();
	const [globalStatus, globalActions] = useGlobal();
	const onChangeHandle = (value) => {
		searchGraph(value, false, props.context, props.entityId).then((response) => {
			setSearchTerm(value)
			setOptions(response)
		}).catch((error) => {
			console.log(error)
		})
	};

	return (
		<div className="context-search-box">
			{
                props.context && props.entityId ?
					<Autocomplete
						id="context-search"
						options={options || []}
						getOptionLabel={option => option.name}
						style = {{width: width > 1000 ? 300: 225 }}
						fullWidth = {false}
						renderOption = { (props, option, state) => {
							return <div className="context-search-option" style={{display: "flex", flexDirection: "row", flexWrap: "nowrap", alignItems: "end"}}>
									<div style={{ fontSize: "smaller", color: "#888", fontWeight: 300, width: "75px", textAlign: "right"}}>
										{props.context}
									</div>
									<div style={{ paddingLeft: "10px", textAlign: "left", width: "225px"}}>
										{props.name}
									</div>
								</div>
						}}
						renderInput={(params) => 
							<TextField {...params} 
								label="Local search" 
								variant="outlined" 
								onChange={ev => {
									// dont fire API if the user delete or not entered anything
									if (ev.target.value !== "" || ev.target.value !== null) {
										onChangeHandle(ev.target.value);
									}
									
									}}/>
						}
						onChange = {(event, value, reason) => {
							console.log(value)
							if (value.context === "site") {
								history.push("/locations/" + value.id)
							} else if (value.context === "building") {
								history.push("/buildings/" + value.id)
							} else if (value.context === "space") {
								history.push("/spaces/" + value.id)
							} else if (value.context === "equipment") {
								history.push("/equipment/" + value.id)
							} 
						}
					}
					/>
				: null }
		</div>
	)
}

export default SearchBox;